import { updateDistanceSelectInDom } from "@modules/azm/filter-selection/distance-select"
import { dispatchGlobalEvent } from "@modules/util/events"
import { advertCardsContainerElement } from "../../global/dom"
import type { Pagination } from "../../types"
import { isMobile, isPC } from "../../util/device"
import { getQueryParameter, removeQueryParameter, setQueryParameter } from "../../util/query-parameter"
import { updateAffiliateAdvertsInDom } from "../affiliates"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { fetchApiWithAllFiltersAddDistance } from "../api"
import { updateSearchTextInDom } from "../filter-selection/searchtext"

// TODO if we need pagination in other sites, separate pagianation and AZM relevant pagination
const loadNextAdvertsDistanceButton = () => document.querySelector<HTMLButtonElement>("#load-adverts-next-distance")
export const loadNextAdvertsButton = () => document.querySelector<HTMLButtonElement>("#load-adverts-next")
export const loadPreviousAdvertsButton = () => document.querySelector<HTMLButtonElement>("#load-adverts-prev")
export const paginationSelect = () => document.querySelector<HTMLSelectElement>("#pagination-select")
const paginationSelectCount = () => document.querySelector<HTMLElement>("#pagination-select-total-pages")
export const paginationSelectBottom = () => document.querySelector<HTMLSelectElement>("#pagination-select-bottom")
const paginationSelectBottomCount = () => document.querySelector<HTMLElement>("#pagination-select-total-pages-bottom")
// bottom buttons only pc available
export const loadPreviousAdvertsButtonBottom = () =>
    document.querySelector<HTMLButtonElement>("#load-adverts-prev-bottom")
export const loadNextAdvertsButtonBottom = () => document.querySelector<HTMLButtonElement>("#load-adverts-next-bottom")
// const DISTANCE_GROUPS = [10, 20, 30, 50, 70, 100, 150, 200, 300]

document.querySelector<HTMLElement>("#azm-seo-href-next")?.addEventListener("click", (event) => {
    event.preventDefault()
})

document.querySelector<HTMLElement>("#azm-seo-href-previous")?.addEventListener("click", (event) => {
    event.preventDefault()
})

document.querySelector<HTMLElement>("#azm-seo-href-next-bottom")?.addEventListener("click", (event) => {
    event.preventDefault()
})
document.querySelector<HTMLElement>("#azm-seo-href-previous-bottom")?.addEventListener("click", (event) => {
    event.preventDefault()
})

let nextPage = 0
let previousPage = 0

export function getNextPage() {
    return nextPage
}

export function setNextPage(page: number) {
    nextPage = page
}

export function getPreviousPageToLoad() {
    return previousPage
}

export function setPreviousPage(page: number) {
    previousPage = page
}

export function getPagination() {
    return SearchConfig.pagination
}

export function getPagesLoadedCount() {
    return getNextPage() - getPreviousPageToLoad() - 1
}

export function setPagination(pagination: Pagination) {
    SearchConfig.pagination.currentPage = pagination.currentPage
    SearchConfig.pagination.totalPages = pagination.totalPages
    setPage(pagination.currentPage)
}

export function getPage() {
    return Number.parseInt(getQueryParameter("page") || "1")
}

export function resetPagination() {
    setPage(1)
    setNextPage(2)
    setPreviousPage(0)
}

export function setPage(page: number) {
    if (page <= 1) {
        removeQueryParameter("page")
    } else {
        setQueryParameter("page", page.toString())
    }
}

export function updatePaginationSelect(pg: Pagination) {
    // only pc has a pagination select right now
    if (isMobile()) {
        return
    }
    const select = paginationSelect()
    const selectCount = paginationSelectCount()
    const selectBottom = paginationSelectBottom()
    const selectBottomCount = paginationSelectBottomCount()
    const selectOptionsHtml = `${[...Array(pg.totalPages).keys()]
        .map(
            (val) =>
                `<lds-option value="${val + 1}" ${getPage() === val + 1 ? "selected" : ""}>${val + 1}</lds-option>`,
        )
        .join("")}`

    if (select) {
        select.innerHTML = selectOptionsHtml
    }
    if (selectBottom) {
        selectBottom.innerHTML = selectOptionsHtml
    }
    if (selectCount) {
        selectCount.innerHTML = pg.totalPages.toString()
    }
    if (selectBottomCount) {
        selectBottomCount.innerHTML = pg.totalPages.toString()
    }
}

export function updatePaginationButtons(pg: Pagination) {
    handlePossibleLoadNextAdvertsButton()
    enableAllPaginationElements()

    // handle pc extra
    if (isPC()) {
        // hide/show paginationContainer
        const paginationContainers = document.querySelectorAll<HTMLElement>(".pagination-container")
        if (pg.totalPages > 1) {
            for (const container of paginationContainers) {
                container.style.display = "flex"
            }
        } else {
            for (const container of paginationContainers) {
                container.style.display = "none"
            }
        }
        // previous buttons
        if (getPage() <= 1) {
            loadPreviousAdvertsButton()?.setAttribute("disabled", "")
            loadPreviousAdvertsButtonBottom()?.setAttribute("disabled", "")
        } else {
            loadPreviousAdvertsButton()?.removeAttribute("disabled")
            loadPreviousAdvertsButtonBottom()?.removeAttribute("disabled")
        }
        // next buttons
        if (getPage() >= pg.totalPages) {
            loadNextAdvertsButton()?.setAttribute("disabled", "")
            loadNextAdvertsButtonBottom()?.setAttribute("disabled", "")
        } else {
            loadNextAdvertsButton()?.removeAttribute("disabled")
            loadNextAdvertsButtonBottom()?.removeAttribute("disabled")
        }
        return
    }

    // mobile
    if (getPreviousPageToLoad() < 1) {
        const btn = loadPreviousAdvertsButton()
        if (btn) btn.style.display = "none"
    }
    const btn = loadNextAdvertsButton()
    if (btn) btn.style.display = getNextPage() > pg.totalPages ? "none" : "inline-block"

    // Monkey fix when user paginates from page 1 to page X, then scrolls to the top again and switches the view type to list or gallery
    // the the loadPreviousButton wouldn't be shown.
    const isOnlyOnePageRendered = (advertCardsContainerElement()?.children.length || 0) < 40
    if (pg.currentPage > 1 && isOnlyOnePageRendered) {
        const btn = loadPreviousAdvertsButton()
        setPreviousPage(pg.currentPage - 1)
        if (btn) btn.style.display = "inline-block"
    }
}

export function showPreviousPaginationButton() {
    const btn = loadPreviousAdvertsButton()
    if (btn) btn.style.display = "inline-block"
}

export function handlePossibleLoadNextAdvertsButton() {
    loadNextAdvertsDistanceButton()?.addEventListener("click", async () => {
        const nextDistanceGroup = loadNextAdvertsDistanceButton()?.getAttribute("data-next-distance")
        if (nextDistanceGroup) {
            loadNextAdvertsDistanceButton()?.setAttribute("loading", "")

            setQueryParameter("umkreis", nextDistanceGroup.toString())
            updateDistanceSelectInDom()

            const result = await fetchApiWithAllFiltersAddDistance()
            loadNextAdvertsDistanceButton()?.remove()
            updateSearchTextInDom()
            await afterFilterApiFetched(result, {
                insertAdjacentHTML: "beforeend",
                removeSamePageContent: true,
            })

            dispatchGlobalEvent("azm.next-distance.after-load", {})
            await updateAffiliateAdvertsInDom()
        }
    })
}

export function disableAllPaginationElements() {
    loadPreviousAdvertsButton()?.setAttribute("disabled", "")
    loadNextAdvertsButton()?.setAttribute("disabled", "")
    loadPreviousAdvertsButtonBottom()?.setAttribute("disabled", "")
    loadNextAdvertsButtonBottom()?.setAttribute("disabled", "")
    paginationSelect()?.setAttribute("disabled", "")
    paginationSelectBottom()?.setAttribute("disabled", "")
}

export function enableAllPaginationElements() {
    loadPreviousAdvertsButton()?.removeAttribute("disabled")
    loadNextAdvertsButton()?.removeAttribute("disabled")
    loadPreviousAdvertsButtonBottom()?.removeAttribute("disabled")
    loadNextAdvertsButtonBottom()?.removeAttribute("disabled")
    paginationSelect()?.removeAttribute("disabled")
    paginationSelectBottom()?.removeAttribute("disabled")
}
